var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.displayLoading ? _c('loading') : _vm._e(), _c('div', {
    staticClass: "container mt-3"
  }, [_vm._m(0), _vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('div', {
    staticClass: "p-3"
  }, [_c('b-card', {
    attrs: {
      "img-src": _vm.avatarUrl,
      "img-alt": "Image",
      "img-top": ""
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('button', {
    staticClass: "btn btn-block btn-outline-primary mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.useLineAvatar
    }
  }, [_vm._v(" 使用LINE頭像 ")]), _c('label', {
    staticClass: "btn btn-block btn-outline-primary m-0",
    attrs: {
      "for": "upload-file"
    }
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "upload-file",
      "hidden": ""
    },
    on: {
      "change": _vm.uploadImage
    }
  }), _c('span', [_vm._v("上傳照片")])])]), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "d-block"
  }, [_vm._v("顯示名稱")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.staff.name,
      expression: "staff.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm.staff.name
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.staff, "name", $event.target.value);
      }
    }
  })])])]), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "outline-dark",
      "disabled": _vm.buttonLoading,
      "block": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 取消 ")])], 1), _c('div', {
    staticClass: "col-6"
  }, [_c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "primary",
      "disabled": _vm.buttonLoading,
      "block": ""
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 送出 ")])], 1)])])], 1)], 1)], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('h1', {
    staticClass: "h5 font-weight-bold mb-0"
  }, [_vm._v("編輯資料")])]);
}]

export { render, staticRenderFns }